import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';
import { timeout } from 'yoda-site-components/lib/lazy/lazyConstants';

export default universal(
    universalImport({
        chunkName: () => 'BazaarVoiceLazy',
        path: () => path.join(__dirname, './BazaarVoice'),
        resolve: () => require.resolveWeak('./BazaarVoice'),
        load: () =>
            Promise.all([import(/* webpackChunkName: "BazaarVoiceLazy" */ './BazaarVoice')]).then(
                (proms) => proms[0]
            ),
    }),
    {
        loading: () => null,
        error: () => null,
        timeout,
    }
);
